module.exports = __webpack_public_path__ + "78a99edc0085cba61b5121e2b6a727e9.svg";